import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=6af47655&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=6af47655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af47655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af47655')) {
      api.createRecord('6af47655', component.options)
    } else {
      api.reload('6af47655', component.options)
    }
    module.hot.accept("./DropdownMenu.vue?vue&type=template&id=6af47655&scoped=true&", function () {
      api.rerender('6af47655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DropdownMenu.vue"
export default component.exports